import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.557 16.022 18.003 16a1 1 0 0 0-.005-2l-6.462.02v-.02l1.256-1.258a1.049 1.049 0 1 0-1.484-1.485l-3 3a1.05 1.05 0 0 0 0 1.485l3 3a1.049 1.049 0 1 0 1.484-1.485zM11 8h10v14H11v-1a1 1 0 1 0-2 0v1.2a1.8 1.8 0 0 0 1.8 1.8h10.4a1.8 1.8 0 0 0 1.8-1.8V7.8c0-.994-.805-1.8-1.8-1.8H10.8A1.8 1.8 0 0 0 9 7.8V9a1 1 0 0 0 2 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }